// Note: Use Enums when you want to use it as a typescript type as well as a constant

enum SIDE {
  BUY = 'buy',
  SELL = 'sell',
}

enum ORDER_TYPE {
  MARKET = 'market_order',
  LIMIT = 'limit_order',
}

enum MARGIN_MODE {
  ISOLATED = 'isolated',
  PORTFOLIO = 'portfolio',
  CROSS = 'cross',
}

// used for local storage
enum STORAGE_KEYS {
  POSITIONS_PLACARD_MOBILE = 'positionsPlacardMobile',
  POSITIONS_PLACARD_TRADE = 'positionsPlacardTrade',
  POSITIONS_PLACARD_ALL_POSITIONS = 'positionsPlacardAllPositions',
  SCANTOLOGIN_PLACARD_MOBILE = 'scanToLoginPlacardMobile',
  MOENGAGE_REGISTERED = 'MOENGAGE_REGISTERED',
  TRACKIER_CLICK_ID = 'tr_click_id',
  MOE_DATA = 'MOE_DATA',
  DELTA_THEME = 'delta_theme',
  TRADINGVIEW_ACTIVE_RESOLUTION = 'trading.time.resolution',
  TRADINGVIEW_LAST_ACTIVE_CHART = 'trading.last.chartType',
  TRADINGVIEW_LAST_ACTIVE_CHART_TAB = 'last-chart-active-tab',
  TRADINGVIEW_IS_ORDERS_DISPLAY = 'tradingview.orders.display',
  LAST_SELECTED_CHART_TAB = 'last-selected-chart-tab',
  PERSIST_ROOT = 'persist:root',
  ORDER_PLACING_BRACKET_ORDER_VISIBILITY = 'order_placing_bracket_order_visibility',
  IS_SAVE_REQUIRED = 'isSavedRequired',
  UPDATE_PASSWORD_POPUP = 'updatePasswordPopup',
  ACCOUNT_CREATED_MODAL_COUNT = 'accountCreatedModalCount',
  ACCOUNT_EQUITY_EYE_VISIBLE = 'accountEquityEyeVisible',
  ETH_OPTIONS_LIQUIDITY_STRIP = '@delta/ethOptionsLiquidityStrip',
  RESET_2FA_POPUP_SHOWN_KEY = 'reset2faPopUpShown',
  STATE_OF_RESIDENCE_MODAL_SHOWN_KEY = 'stateofResidenceModalShown',
  STATE_OF_RESIDENCE_MODAL_CLOSED_TIME = 'stateofResidenceModalClosedTime',
  ADD_BANK_AFTER_SUCCESSFUL_MODAL_MOBILE = 'hasAddBankSuccessfulModalShown',
  /* stores the value of strip which is currently viewed */
  INFORMATION_STRIP = '@delta/informationStrip',
  /** Stores whether to hide assets with zero balance in wallet menu.local storage being used because we need to keep this value in sync with web app and page */
  HIDE_ASSET_WITH_ZERO_BALANCE = '@delta/hideAssetWithZeroBalance',
  /**
   * @summary BIOMETRIC_AUTH_STATUS is used to store the status of current biometric preference.
   */
  BIOMETRIC_AUTH_STATUS = '@delta/biometricAuthStatus',
  BIOMETRICS_LOGOUT_ON_INIT = '@delta/biometricsLogoutOnInit',
  BIOMETRICS_LOGIN_METADATA = '@delta/biometricsLoginMetadata',
  BIOMETRICS_CONFIG = '@delta/biometricsConfig',

  PAGE_RELOADED = '@delta/pageReloaded',
  PREVIOUS_PATH_NAME = 'previousPathName',

  LINK_OAUTH_EMAIL = 'link-oauth-email',
  LINK_OAUTH_JWT_TOKEN = 'link-oauth-jwtToken',
  LINK_OAUTH_PROVIDER = 'link-oauth-provider',
  OAUTH_LANDING_PAGE_PRE2FA_EMAIL = 'oauth-landing-page-pre2fa-email',
  OAUTH_LANDING_PAGE_PRE2FA_CODE = 'oauth-landing-page-pre2fa-code',
  OAUTH_LANDING_PAGE_PRE2FA_TOKEN = 'oauth-landing-page-pre2fa-token',
  SHOW_BALANCE = 'account-balance',
  OAUTH_LANDING_PAGE_PHONE_OTP_REQUIRED = 'oauth-landing-page-phone-otp_required',
  OPTIONS_CHAIN_CUSTOMISABLE = 'options-chain-customisable',
  PRICE_ALERT_PLACARD = '@delta/price-alert-placard',

  /**
   * @summary When user gets approved or needs_review state from sdk we don't have to show Hyperverge cta for 5 minutes.
   * As internal state gets removed after refresh so maintaining in local storage.
   */
  HYPERVERGE_LAST_BLOCK_TIME = `@delta/hypervergeLastBlockTime`,

  OPTION_COMBOS_SLIDES = 'isOptionCombosSlidesShown',
  MOBILE_HOLDING_ACTIVE_TAB = 'mobileHoldingActiveTab',

  OPTIONS_CHAIN_STRIP_SEEN = 'isOptionsChainStripSeen',
  HOMEPAGE_TOP_SECTION_CARD_TYPE = 'homePageTopSectionCardType',
  PLACE_ORDER_QTY_INPUT_TRACK_TIME = '@delta/quantityInputLastTrackedTime',
  PLACE_ORDER_PRICE_INPUT_TRACK_TIME = '@delta/priceInputLastTrackedTime',

  SHOW_OPTIONS_ANALYTICS_ROTATE_MESSAGE = '@delta/showOptionsAnalyticsRotateMessage',
  MOBILE_POSITIONS_VIEW_MODE = 'mobilePositionsViewMode',
  HOLDINGS_TABLE_ACTIVE_TAB = 'holdings_table_active_tab',
  KYC_SHARE_CONSENT_POPUP_SEEN = '@delta/kycShareConsentPopupSeen',

  FEAT_TOGGLE_CURRENCY = 'toogle-currency-current-value',
  DEPOSIT_NO_ACTION_NEEDED_MESSAGE_SEEN = '@delta/depositNoActionNeededMessageseen',
  UTM_PARAMETERS = 'utmParameters',

  BRACKET_ORDER_TRIGGER_INDEX = 'bracket-order-trigger-index',
  /**
   * @description this is used to store the performance data for network requests which are not cached,
   * So that it can be send when headers data is present in cache storage */
  UN_CACHED_NETWORK_PERFORMANCE_DATA = '@delta/unCachedNetworkPerformanceData',
  INDIA_OR_GLOBAL_MODAL_CHOICE = '@delta/indiaOrGlobalModalChoice',
  INDIA_OR_GLOBAL_MODAL_SESSION_CHOICE = '@delta/indiaOrGlobalModalSessionChoice',
  SHOW_TRANSFER_FUND_MODAL = 'showTransferFundModal',

  TRADE_SUCCESS_CARD_CLOSE_TIME = 'trade_success_card_close_time',

  TRADE_SUCCESS_SHARE_CARD_DATA_LOADED = '@delta/tradeSuccessShareCardDataLoaded',
  IDFY_BLOCKED_TIMESTAMP_FOR_USER = '@delta/idfyBlockedTimestampForUser',
  USER_ID_POST_2FA_RESET = '@delta/setup2faModalUserId',
  LEVERAGE_ACKNOWLEDGE_MODAL = '@delta/leverageacknowledgeModal',
  SCALPER_OFFER_STRIP_SHOWN_KEY = '@delta/scalperOfferStripShownKey',
  KYC_REFRESH_DEADLINE_STRIP_CLOSE_TIME = 'kycDeadlineStripClosingTime',
  USER_NOTIFICATION_PERMISSION_GRANTED = '@delta/userNotificationPermissions',

  CHART_LAST_SUBSCRIPTION_ID = 'lastSUID',
  TRACKER_ACKNOWLEDGE_MODAL = '@delta/trackeracknowledgeModal',
  INCOME_SOURCE_DISMISSED = '@delta/incomeSourceDismissed',
  POSITION_ANALYTICS_GROUP_BY_EXPIRY = '@delta/positionAnalyticsMobileGroupByExpiry',
  POSITION_ANALYTICS_DESKTOP_ASSET_TAB_SELECTED = '@delta/positionAnalyticsDesktopAssetTabSelected',
  SPOT_WALLET_AMOUNT_VISIBLE = '@delta/spotWalletAmountVisible',
}

enum SESSION_STORAGE_KEYS {
  FROM_V2_PLACE_ORDER = 'fromV2PlaceOrder',
  SPOT_TRADING_CAME_FROM = 'spotTradingCameFrom',
}

enum POST_MESSAGE_TO_MOBILE_EVENTS {
  USER_AUTHORIZED = 'USER_AUTHORIZED',
  SEND_APPS_FLYER_ID = 'SEND_APPS_FLYER_ID',
  OPEN_LINK_IN_EXTERNAL_BROWSER = 'OPEN_LINK_IN_EXTERNAL_BROWSER',
  APP_LOADED = 'APP_LOADED',
  BIOMETRICS_MESSAGES = 'BIOMETRICS_MESSAGES',
  LAUNCH_HYPERVERGE_SDK_KYC = 'LAUNCH_HYPERVERGE_SDK_KYC',
  LAUNCH_SHUFTIPRO_SDK_KYC = 'LAUNCH_SHUFTIPRO_SDK_KYC',
  OAUTH_BUTTON_CLICKED = 'OAUTH_BUTTON_CLICKED',
  OAUTH_LOGOUT = 'OAUTH_LOGOUT',
  FILE_DOWNLOAD_REQUEST = 'FILE_DOWNLOAD_REQUEST',
  LOGOUT = 'LOGOUT',
  LAUNCH_REACT_NATIVE_SHARE_OPEN = 'LAUNCH_REACT_NATIVE_SHARE_OPEN',
  LAUNCH_REACT_NATIVE_SHARE_SINGLE = 'LAUNCH_REACT_NATIVE_SHARE_SINGLE',
  STORE_BASE64_IMAGES_IN_MEDIA = 'STORE_BASE64_IMAGES_IN_MEDIA',
  LAUNCH_IN_APP_REVIEW = 'LAUNCH_IN_APP_REVIEW',
  CONSOLE = 'CONSOLE',
  TRACKIER_EVENT = 'TRACKIER_EVENT',
  LOGIN_CLICKED = 'LOGIN_CLICKED',
  SIGNUP_CLICKED = 'SIGNUP_CLICKED',
  LAUNCH_IDFY_KYC_WEBVIEW = 'LAUNCH_IDFY_KYC_WEBVIEW',
  CAMERA_PERMISSION = 'CAMERA_PERMISSION',
  THEME_CHANGE = 'THEME_CHANGE',
  APPSFLYER_SIGNUP = 'APPSFLYER_SIGNUP',
  SIGNUP_NOTIFICATION_SUCCESS = 'SIGNUP_NOTIFICATION_SUCCESS',
  APPSFLYER_ORDER = 'APPSFLYER_ORDER',
  GO_BACK = 'GO_BACK',
  GO_TO_HOME = 'GO_TO_HOME',
  OPEN_QR_LOGIN_SCANNER = 'OPEN_QR_LOGIN_SCANNER',
  GO_TO_MARKETS = 'GO_TO_MARKETS',
  OPEN_APP_SETTINGS = 'OPEN_APP_SETTINGS',
  CHECK_NOTIFICATION_PERMISSION = 'CHECK_NOTIFICATION_PERMISSION',
  LAUNCH_NATIVE_REKYC_SELFIE_VERIFICATION = 'LAUNCH_NATIVE_REKYC_SELFIE_VERIFICATION',
  UPDATE_MARGIN_MODE_WEB = 'UPDATE_MARGIN_MODE_WEB',
  GO_TO_PORTFOLIO = 'GO_TO_PORTFOLIO',
  UPDATE_USER_PREFERENCE = 'UPDATE_USER_PREFERENCE',
  UPDATE_SUB_ACCOUNT = 'UPDATE_SUB_ACCOUNT',
  UPDATE_SHOW_EQUITY = 'UPDATE_SHOW_EQUITY',

  /**
   * @description These events are used to select available mobile numbers on the phone
   * and automaticatically fetch the otp from SMS
   */
  SHOW_SELECT_PHONE_NUMBER_POPUP = 'SHOW_SELECT_PHONE_NUMBER_POPUP',
  GET_HASH_CODE = 'GET_HASH_CODE',
  FETCH_OTP_FROM_SMS = 'FETCH_OTP_FROM_SMS',
  REMOVE_OTP_LISTENER = 'REMOVE_OTP_LISTENER',
  UPDATE_ORDER_POSITION = 'UPDATE_ORDER_POSITION',
  /**
   * @description This event is used to notify the mobile app when full screen view changes
   */
  FULL_SCREEN_STATUS = 'FULL_SCREEN_STATUS',
  WEBVIEW_BACK_ENABLED = 'WEBVIEW_BACK_ENABLED',
  WITHDRAWAL_REQUEST = 'WITHDRAWAL_REQUEST',
  DEPOSIT_REQUEST = 'DEPOSIT_REQUEST',
}

enum PLACE_ORDER_TYPE {
  LIMIT = 'limit',
  MARKET = 'market',
  STOP_MARKET = 'Stop Market',
  STOP_LIMIT = 'Stop Limit',
  TRAILING_STOP = 'Trailing Stop',
  TAKE_PROFIT_MARKET = 'Take Profit Market',
  TAKE_PROFIT_LIMIT = 'Take Profit Limit',
  MAKER_ONLY = 'Maker Only',
}

enum POSITION_TYPE {
  LONG = 'Long',
  SHORT = 'Short',
}

enum SCREEN_SIZES {
  XS = 576,
  SM = 768,
  MD = 1024,
  LG = 1280,
  XL = 1440,
}

enum CURRENCY_TYPE {
  INR = 'INR',
  USDT = 'USDT',
  BTC = 'BTC',
  USD = 'USD',
  DETO = 'DETO',
  ETH = 'ETH',
  XRP = 'XRP',
  BNS = 'BNS',
  SOL = 'SOL',
  USDC = 'USDC',
}

enum API_STATUS {
  IDLE = 'idle',
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
  INITIAL = 'initial',
}

enum CURRENCY_SYMBOL {
  INR = '₹',
  USD = '$',
  USDT = '$',
}

enum OAUTH_PROVIDERS {
  APPLE = 'apple',
  GOOGLE = 'google',
}

enum ORDER_BOOK_TAB_TYPES {
  BOTH = 'both',
  SELL = 'sell',
  BUY = 'buy',
}

enum FUND_TYPE {
  MARKET_MAKING_POOL_FUND = 'market_making_pool_fund',
  STAKING_POOL = 'staking_pool',
  COVERED_OPTIONS = 'covered_options',
}

enum POSITION_ACTION_MODAL_MODES {
  CLOSE_MODE = 'CLOSE_MODE',
  CANCEL_MODE = 'CANCEL_MODE',
}

enum TRANSACTION_PARTNER_NAMES {
  DE_INTERNAL = 'de_internal',
  VAN = 'VAN',
  TRANSBANK = 'transbank',
}

// Methods by which user can recover their account
enum RECOVER_VERIFICATION_METHOD {
  FACE_AUTH = 'face_auth',
  KYC = 'kyc',
}

enum RECOVER_USER_ACCOUNT_KYC_LEVEL {
  ADDRESS_VERIFICATION = 'address_verification',
  IDENTITY_VERIFICATION = 'identity_verification',
}

enum KYC_VENDOR {
  IDFY = 'idfy',
  HYPERVERGE = 'hyperverge',
  SHUFTIPRO = 'shuftipro',
}

enum CHART_TABS {
  PRICE_CHART = 'price-chart',
  MARK_CHART = 'mark-chart',
  FUNDING_CHART = 'funding-chart',
  DEPTH_CHART = 'depth-chart',
  INDEX_PRICE_CHART = 'underlying-chart',
}

enum STATIC_MARKETING_OFFER_VALUES {
  SCALPER_OFFER = '1',
  ALGO_MARKETPLACE = '10',
}

enum BANK_TYPE {
  /**
   * Equitas Bank
   */
  EQ = 'EQ',
  /**
   * Indian Bank
   */
  IB = 'IB',
  /**
   * Shivalik Bank
   */
  SN = 'SN',
  /**
   * AU Bank
   */
  AU = 'AU',
}
enum FACE_AUTH_STATUS {
  // When user has requested face auth flow.
  PENDING = 'pending',
  // User Successfully enrolled on hyperverge for face auth. Not used in fe.
  ENROLLED = 'enrolled',
  // final state for twofa flow , two_factor_reset is done
  TWO_FACTOR_RESET = 'two_factor_reset',
  // face auth failed by backend
  FAILED = 'failed',
  // final state for other flows .except twofa
  COMPLETED = 'completed',
}

enum FILE_SIZE_UNIT {
  KB = 'KB',
  MB = 'MB',
  GB = 'GB',
}

enum FILE_SIZE_VALUE_IN_KB {
  ONE_KB = 1,
  ONE_MB = 1024,
  ONE_GB = 1024 * 1024,
}

enum GREEK_TYPES {
  DELTA = 'DELTA',
  GAMMA = 'GAMMA',
  THETA = 'THETA',
  VEGA = 'VEGA',
}

enum ORDER_CATEGORY {
  OPEN_ORDER = 'OPEN_ORDER',
  STOP_ORDER = 'STOP_ORDER',
}

enum TIMESTAMP_FILTER {
  SEVEN_DAYS = '7 Days',
  ONE_MONTH = '30 Days',
  NINETY_DAYS = '90 Days',
  LAST_FIY = 'Last FY',
  CURRENT_FIY = 'Current FY',
  CUSTOM = 'custom',
}

enum TRADE_PAGE_VERIFICATION_FLAGS {
  GET_VERIFIED = 'GET_VERIFIED',
  REDUCE_ONLY = 'REDUCE_ONLY',
  RENEW_KYC = 'RENEW_KYC',
  REDUCE_ONLY_NRI = 'REDUCE_ONLY_NRI',
}
enum SOURCE_FOR_MIXPANEL_EVENTS {
  POSITIONS = 'Positions',
  CHART = 'Chart',
  ORDER_PLACEMENT = 'Order Placement',
  HOLDINGS_POSITIONS = 'Holdings Positions',
  BROKER_CHART = 'CHART_BROKER', // used for interactions with chart elements; implemented by broker API from trading platform
  TRADE_PAGE = 'TRADE_PAGE', // Mobile trade holdings section on the trade page
}

enum ANALYTICS_DEVICE_OS_TYPE {
  ANDROID = 'android',
  IOS = 'ios',
  WINDOWS = 'windows',
  UNKNOWN = 'unknown',
  WEB = 'web',
  ANDROID_WEB = 'android_web',
  IOS_WEB = 'ios_web',
}

enum REKYC_FLOW {
  FACE_AUTH = 'face_auth',
  FULL_VERIFICATION = 'full_kyc',
}

enum NOTIONAL_TYPES {
  INVERSE = 'inverse',
  VANILLA = 'vanilla',
}

enum NRI_STATUS_VALUES {
  NOT_NRI = 'not_nri',
  POTENTIAL_NRI = 'potential_nri',
  REDUCE_ONLY = 'reduce_only',
  POSITIONS_CLOSED = 'positions_closed',
  WITHDRAWAL_RAISED = 'withdrawal_raised',
  WITHDRAWAL_SUCCESS = 'withdrawal_success',
  REFERRAL_WITHDRAWAL_RAISED = 'referral_withdrawal_raised',
  REFERRAL_WITHDRAWAL_SUCCESS = 'referral_withdrawal_success',
  OFFBOARDED = 'offboarded',
}

enum ORDER_SOURCE_TYPE {
  PLACE_ORDER = 'place_order', // legacy + v2 placeorder even if it contains tp/sl bracket order(s) combined
  CHARTS_TAB_BUY_SELL = 'charts_tab_buy_sell', // v2 placeorder chart tab mobile view only

  CHARTS_PLUS_BUTTON = 'charts_plus_button', // quick order only all dropdowns
  OPEN_ORDER_EDIT = 'open_order_edit', // all edits in open order/stop order except bracket order ones
  CHARTS_BUY_SELL = 'charts_buy_sell', // todo - will be used after WEB-6238
  BASKET_ORDER = 'basket_order', // via strategy builder

  // all create/edits in positions tab for tp/sl
  POSITIONS_TP_SL_ORDER = 'positions_TP_SL_order',
  POSITIONS_TP_SL_EDIT_ORDER = 'positions_TP_SL_edit_order',

  // click on order line and then click & drag TP/SL button to create/edit orders
  CHARTS_TP_ORDER = 'charts_TP_order',
  CHARTS_SL_ORDER = 'charts_SL_order',
  CHARTS_TP_EDIT_ORDER = 'charts_TP_edit_order',
  CHARTS_SL_EDIT_ORDER = 'charts_SL_edit_order',
}

export {
  ANALYTICS_DEVICE_OS_TYPE,
  API_STATUS,
  BANK_TYPE,
  CHART_TABS,
  CURRENCY_SYMBOL,
  CURRENCY_TYPE,
  FACE_AUTH_STATUS,
  FUND_TYPE,
  GREEK_TYPES,
  KYC_VENDOR,
  MARGIN_MODE,
  OAUTH_PROVIDERS,
  ORDER_BOOK_TAB_TYPES,
  ORDER_CATEGORY,
  ORDER_TYPE,
  PLACE_ORDER_TYPE,
  POSITION_ACTION_MODAL_MODES,
  POSITION_TYPE,
  POST_MESSAGE_TO_MOBILE_EVENTS,
  RECOVER_USER_ACCOUNT_KYC_LEVEL,
  RECOVER_VERIFICATION_METHOD,
  SCREEN_SIZES,
  SIDE,
  SESSION_STORAGE_KEYS,
  SOURCE_FOR_MIXPANEL_EVENTS,
  STATIC_MARKETING_OFFER_VALUES,
  STORAGE_KEYS,
  TIMESTAMP_FILTER,
  TRADE_PAGE_VERIFICATION_FLAGS,
  TRANSACTION_PARTNER_NAMES,
  REKYC_FLOW,
  FILE_SIZE_UNIT,
  FILE_SIZE_VALUE_IN_KB,
  NOTIONAL_TYPES,
  NRI_STATUS_VALUES,
  ORDER_SOURCE_TYPE,
};
